module.exports = __webpack_public_path__ + "img/House-MVPs.a3e8d3be.png";